import {request} from './client.js'

/**
 * @param {{assignee?: 'me'|'all'|string}} [filters]
 * @return {Promise<{tasks: import('./types.js').Task[]}>}
 */
export function listTasks(filters = {}) {
    const qs = new URLSearchParams()
    if (filters.assignee)
        qs.set('assignee', filters.assignee)
    const suffix = qs.toString() ? `?${qs}` : ''
    return request('GET', `/tasks${suffix}`)
}

/**
 * @param {string} id
 * @return {Promise<{task: import('./types.js').Task, comments: import('./types.js').TaskComment[]}>}
 */
export function getTask(id) {
    return request('GET', `/tasks/${id}`)
}

/**
 * @param {{title: string, description?: string, assigneeId: string, priority?: number, dueAt?: string}} payload
 */
export function createTask(payload) {
    return request('POST', '/tasks', {body: payload})
}

/**
 * @param {string} id
 * @param {Partial<{title: string, description: string, assigneeId: string, priority: number, dueAt: string}>} patch
 */
export function updateTask(id, patch) {
    return request('PUT', `/tasks/${id}`, {body: patch})
}

/**
 * @param {string} id
 * @param {import('./types.js').TaskStatus} status
 */
export function setTaskStatus(id, status) {
    return request('POST', `/tasks/${id}/status`, {body: {status}})
}

/**
 * @param {string} id
 * @param {string} body
 */
export function addTaskComment(id, body) {
    return request('POST', `/tasks/${id}/comments`, {body: {body}})
}

/**
 * @param {string} id
 */
export function deleteTask(id) {
    return request('DELETE', `/tasks/${id}`)
}
